import type { CellStyle } from './cellStyle';
import { type StoredStyle, type StyleToMerge, mergeStyles } from './types';

// TODO: add a "bottom/right of table" style for printing
export class ColRowStyle {
  constructor(
    public readonly from: number = 0,
    public readonly to: number = Infinity,
    public readonly cellStyle: StoredStyle<CellStyle> = {},
  ) {}

  public withFrom(from: number) {
    return new ColRowStyle(from, this.to, this.cellStyle);
  }

  public withTo(to: number) {
    return new ColRowStyle(this.from, to, this.cellStyle);
  }

  public withStyle(style: StyleToMerge<CellStyle>) {
    return new ColRowStyle(
      this.from,
      this.to,
      mergeStyles(this.cellStyle, style),
    );
  }
}

export class ColRowStyles {
  constructor(public readonly styles: readonly ColRowStyle[] = []) {}

  public withStyle(style: ColRowStyle): ColRowStyles {
    // TODO: merge styles
    return new ColRowStyles([...this.styles, style]);
  }

  public *getStyles(index: number): Iterable<ColRowStyle> {
    for (const style of this.styles.toReversed()) {
      if (index >= style.from && index <= style.to) {
        yield style;
      }
    }
  }

  public cellStyleAt(index: number): StoredStyle<CellStyle> {
    let style: StoredStyle<CellStyle> = {};
    for (const s of this.getStyles(index)) {
      style = mergeStyles(style, s.cellStyle);
    }
    return style;
  }
}
